import { COLLECTIONS } from '__constants__'
import { useCollection } from 'services/api/firebase'
import { useMemo } from 'react'

/**
 * It returns an array of values that are used to render the complaints
 * @param props - An object that contains the query parameters.
 * @returns An array of values.
 */
const useGetRefund = (orderId) => {
  /* Query for getting collection reference */
  const query = useMemo(
    () => ({
      ref: COLLECTIONS.STRIPE_REFUNDS,
      where: [['orderId', '==', orderId]]
    }),
    [orderId]
  )

  /* Getting collection data */
  const [value, loading, error, next, loadingMore, loadMoreAvailable] =
    useCollection(query)

  return [value, loading, error, next, loadingMore, loadMoreAvailable]
}

export default useGetRefund
